import { MenuItemInterface } from 'common/components/entities/Menu/types/MenuInterface'

export const hasSubMenu = (menuItem: MenuItemInterface): boolean => {
  return (menuItem.subMenuItems?.length || 0) > 0
}
